import React, { useState } from 'react';
import { Box, Typography, IconButton, Collapse } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

const FinancialDisclaimer = () => {
    const [visible, setVisible] = useState(true);

    if (!visible) return null;

    return (
        <Collapse in={visible}>
            <Box sx={{
                position: 'fixed',
                top: 24,
                left: 24,
                zIndex: 9999,
                maxWidth: 320,
                display: 'flex',
                alignItems: 'flex-start',
                gap: 1.5,
                p: 2,
                borderRadius: 2,
                background: 'rgba(15, 23, 42, 0.7)',
                backdropFilter: 'blur(12px)',
                border: '1px solid rgba(251, 191, 36, 0.2)',
                boxShadow: '0 8px 32px rgba(0, 0, 0, 0.4)',
                transition: 'all 0.3s ease',
                '&:hover': {
                    background: 'rgba(15, 23, 42, 0.9)',
                    border: '1px solid rgba(251, 191, 36, 0.4)',
                }
            }}>
                <WarningAmberIcon sx={{ color: '#fbbf24', fontSize: '1.2rem', mt: 0.2 }} />
                <Typography sx={{
                    color: '#e2e8f0',
                    fontSize: '0.8rem',
                    lineHeight: 1.5,
                    fontWeight: 400,
                    flex: 1
                }}>
                    <strong style={{ color: '#fbbf24' }}>Not Financial Advice:</strong><br />
                    Data for educational purposes only. Consult a professional before investing.
                </Typography>
                <IconButton
                    size="small"
                    onClick={() => setVisible(false)}
                    sx={{
                        color: '#94a3b8',
                        p: 0.5,
                        mt: -0.5,
                        mr: -0.5,
                        '&:hover': { color: '#fbbf24', background: 'rgba(251, 191, 36, 0.1)' }
                    }}
                >
                    <CloseIcon fontSize="small" />
                </IconButton>
            </Box>
        </Collapse>
    );
};

export default FinancialDisclaimer;
